import {AbstractControl, ValidationErrors, ValidatorFn, Validators} from '@angular/forms';

export const requiredValidator = (message: string): ValidatorFn => (control: AbstractControl): ValidationErrors | null => {
    const validationErrors = Validators.required(control);
    if (validationErrors) {
        return {
            required: message
        };
    }
    return null;
};
